
(function(){
    document.addEventListener("DOMContentLoaded", function (event) {
        var links = document.getElementsByClassName('cc-expandable-text_link');
        var i;
        for (i=0; i< links.length; i++){
            links[i].addEventListener('click', function(event){
                event.preventDefault();
                var content = this.parentNode.parentNode.querySelector('.cc-expandable-text_content');
                if(content.style.display === 'none'){
                    content.style.display = 'inline';
                    this.text = this.getAttribute('data-less')
                }else{
                    content.style.display = 'none';
                    this.text = this.getAttribute('data-more')
                }

            });
        }

    });
}());
